import i18next from "i18next";
import XHR from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

i18next
  .use(XHR)
  .use(initReactI18next)
  .init({
    backend: { loadPath: `./locales/{{lng}}.json` },
    react: { useSuspense: false },
    lng: "de",
    fallbackLng: "de",
    preload: ["de", "en"],
    keySeparator: false,
    interpolation: { escapeValue: false },
  });

export default i18next;
